import { FormControl, ValidatorFn } from "@angular/forms";

export const OnlyAlphaNumericValidator: ValidatorFn = (
  control: FormControl
) => {
  if (!/^[a-z0-9 ]+$/i.test(control.value)) {
    return {
      invalidError: { value: "Invalid account name" },
    };
  }
  if (control.value.endsWith(" ") || control.value.startsWith(" ")) {
    return {
      invalidError: { value: "Invalid account name" },
    };
  }
  return null;
};
